import LastComment from './LastComment'

export default LastComment
